package com.exura.features.plandefinition.data.mappers.plandefinition

import com.exura.features.plandefinition.data.remote.dto.plan.TreatmentPlanDto
import com.exura.features.plandefinition.domain.model.plan.TreatmentPlan
import dev.gitlive.firebase.firestore.CollectionReference

class TreatmentPlanMappers : PlanMappers<TreatmentPlan, TreatmentPlanDto> {
    override fun toDto(model: TreatmentPlan): TreatmentPlanDto {
        return TreatmentPlanDto(
            title = model.title,
            description = model.description,
            durationInDays = model.durationInDays(),
            imageUrl = model.imageUrl,
        )
    }

    override fun toDomain(dto: TreatmentPlanDto, collection: CollectionReference?, id: String?): TreatmentPlan {
        return TreatmentPlan(
            firebaseDocId = id,
            firebaseDocPrefix = collection,
            title = dto.title,
            description = dto.description,
            collections = emptyList(),
            directSeries = emptyList(),
            imageUrl = dto.imageUrl,
        )
    }
}
